import { render, staticRenderFns } from "./abnormal-pie-chart.vue?vue&type=template&id=83cbb2d8"
import script from "./abnormal-pie-chart.vue?vue&type=script&lang=js"
export * from "./abnormal-pie-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports